import { Fragment, useEffect, useState } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';

import ConfirmedOfferCard from './ConfirmedOfferCard';
import IndicativeOfferCard from './IndicativeOfferCard';
import { OfferHeading } from './OfferHeading';
import styles from './Offers.module.css';
import { singleDigitToWord } from '../../helpers/singleDigitToWord';
import { useSignupRouterUK } from '../../hooks/useSignupRouter/useSignupRouterUK';
import { useGetStateQuery } from '../../lendingApi/lendingApiQueries';
import { TGetOffersResponse, TGetStateResponse } from '../../types';
import { getAmplitudeDefaultEventProperties } from '../../utils/amplitudeEvents';
import { Button } from '../Button/Button';

type TProps = {
  offers: TGetOffersResponse['data']['offers'];
};

const Offers = ({ offers }: TProps) => {
  const [isNavigatingBack, setIsNavigatingBack] = useState(false);

  const { state, isStateFetching } = useGetStateQuery<TGetStateResponse>();

  const { navigateSignup } = useSignupRouterUK();

  useEffect(() => {
    // TODO: remove when no longer needed
    tracking.ampli.indicativeOffersViewed(getAmplitudeDefaultEventProperties());

    tracking.ampli.stepLoaded({
      'Step name': 'Pre-DC offers',
      ...getAmplitudeDefaultEventProperties(),
    });
  }, []);

  const getTitle = () => {
    const numberOfOffers = singleDigitToWord(offers.length);
    return `Good news! We've got ${numberOfOffers} offers for you`;
  };

  const handleClick = async () => {
    let hasSeenAccountCreatedModal = state.ui?.hasSeenAccountCreatedModal;

    if (!hasSeenAccountCreatedModal) {
      const dateNow = new Date();
      dateNow.setMinutes(-1 * dateNow.getTimezoneOffset());

      hasSeenAccountCreatedModal = dateNow.toISOString();
    }

    setIsNavigatingBack(true);

    tracking.ampli.backCtaClicked(getAmplitudeDefaultEventProperties());

    await navigateSignup({
      route: 'applicant',
      updatedState: {
        ...state,
        ui: {
          ...state.ui,
          hasSeenAccountCreatedModal,
        },
      },
    });

    setIsNavigatingBack(false);
  };

  return (
    <div className={styles.container}>
      <OfferHeading
        title={getTitle()}
        subtitle="All options have no early repayment fees"
      />
      {offers.map((offer) => {
        return (
          <Fragment key={offer.offer_id}>
            {offer.offer_type === 'confirmed' ? (
              <ConfirmedOfferCard {...offer} />
            ) : (
              <IndicativeOfferCard {...offer} />
            )}
          </Fragment>
        );
      })}
      <Button
        variant="tertiary"
        className={styles.button}
        disabled={isStateFetching}
        loading={isNavigatingBack}
        onClick={handleClick}
      >
        Back
      </Button>
    </div>
  );
};

export default Offers;
